// Configuration objects for different environments
const PREPROD_CONFIG = Object.freeze({
  currentEnvironment: "preprod",

  deeplinkBaseUrl: {
    preprod: "https://genius.devinfinitylearn.in/",
    staging: "https://genius.devinfinitylearn.in/",
    prod: "https://genius.infinitylearn.com/deeplink/exampage",
  },

  scholarshipTestBaseUrl: {
    preprod: "https://scholarshiptest.devinfinitylearn.in/",
    staging: "https://scholarshipteststaging.devinfinitylearn.in/",
    prod: "https://scholarshiptest.infinitylearn.com/",
  },
  learnScholarshipTestBaseUrl: {
    preprod: "https://learnscholarshiptest.devinfinitylearn.in/",
    staging: "https://learnscholarshiptest-staging.devinfinitylearn.in/",
    prod: "https://learnscholarshiptest.infinitylearn.com/",
  },

  baseUrl: {
    1: "https://inmobiusjob.devinfinitylearn.in/api", // pre-prod URL
  },

  gatewayBaseUrl: {
    1: "https://gatewayapi.devinfinitylearn.in/api", //preprod
  },

  inmobiusJobBaseUrl: {
    1: "https://inmobiusjob.devinfinitylearn.in/api", // preprod
  },

  schoolReportBaseUrl:
    "https://geniusreports.devinfinitylearn.in/school-report",

  gatewayApiSecretKey: "PMA4qXWFZ3uJstb8qtYWVjiFLgtAsm8UULe7cuhGydsdKcwJ", // preprod
  apiKey: "PMA4qXWFZ3uJstb8qtYWVjiFLgtAsm8UULe7cuhGydsdKcwJ", //preprod
  apiVersion: "v1",
  gatewayApiVersion: "v1",
  inmobiusJobApiVersion: "v1",

  roleMappings: {
    1: {
      5: "Super Admin",
      47: "MIS Team Admin",
      48: "General Manager",
      49: "Senior Manager",
      50: "Manager",
      51: "Execution Rep",
      52: "School Admin",
    },
  },

  hierarchy_role_ids: {
    1: {
      "Senior Manager": 49,
      Manager: 50,
      "Execution Rep": 51,
    },
  },
});

const PRODUCTION_CONFIG = Object.freeze({
  currentEnvironment: "prod",

  deeplinkBaseUrl: {
    preprod: "https://genius.devinfinitylearn.in/",
    staging: "https://genius.devinfinitylearn.in/",
    prod: "https://genius.infinitylearn.com/",
  },

  scholarshipTestBaseUrl: {
    preprod: "https://scholarshiptest.devinfinitylearn.in/",
    staging: "https://scholarshipteststaging.devinfinitylearn.in/",
    prod: "https://scholarshiptest.infinitylearn.com/",
  },
  learnScholarshipTestBaseUrl: {
    preprod: "https://learnscholarshiptest.devinfinitylearn.in/",
    staging: "https://learnscholarshiptest-staging.devinfinitylearn.in/",
    prod: "https://learnscholarshiptest.infinitylearn.com/",
  },
  baseUrl: {
    1: "https://inmobiusjob.infinitylearn.com/api", // prod URL
  },

  gatewayBaseUrl: {
    1: "https://gatewayapiinmobius.infinitylearn.com/api", // prod URL
  },

  inmobiusJobBaseUrl: {
    1: "https://inmobiusjob.infinitylearn.com/api", // prod
  },

  schoolReportBaseUrl: "https://geniusreports.infinitylearn.com/school-report",

  gatewayApiSecretKey: "MtgZCn5NMS5lgp7m0NYSvB9Rb7jOVvKZcDm5cLgTWjVXdFG0Js", //prod
  apiKey: "MtgZCn5NMS5lgp7m0NYSvB9Rb7jOVvKZcDm5cLgTWjVXdFG0Js", //prod
  apiVersion: "v1",
  gatewayApiVersion: "v1",
  inmobiusJobApiVersion: "v1",

  roleMappings: {
    1: {
      5: "Super Admin",
      45: "MIS Team Admin",
      46: "General Manager",
      47: "Senior Manager",
      48: "Manager",
      49: "Execution Rep",
      50: "School Admin",
    },
  },

  hierarchy_role_ids: {
    1: {
      "Senior Manager": 47,
      Manager: 48,
      "Execution Rep": 49,
    },
  },
});

// Function to determine current environment based on hostname
function getCurrentEnvironment() {
  if (typeof window !== "undefined" && window.location) {
    const hostname = window.location.hostname;

    // Production hostname
    if (hostname === "adminv2.inmobiusinfinitylearn.com") {
      return "production";
    }

    // Preprod hostnames (including localhost and 127.0.0.1 for development)
    if (
      hostname === "adminpreprodv2.inmobiusinfinitylearn.com" ||
      hostname === "localhost" ||
      hostname === "127.0.0.1"
    ) {
      return "preprod";
    }
  }

  // Default fallback to preprod for development/unknown environments
  return "preprod";
}

// Export the appropriate configuration based on current hostname
export const CONFIG_VARS =
  getCurrentEnvironment() === "production" ? PRODUCTION_CONFIG : PREPROD_CONFIG;
